"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTrophyFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 6h-7V2H9v13.6a10.92 10.92 0 01-3.22-3.26A11.34 11.34 0 014.1 8H9V6H2v1a12.74 12.74 0 002.1 6.44 12.27 12.27 0 005 4.48c.3 3.64 2.33 5.7 5.94 6V28H8v2h16v-2h-7v-4c3.59-.33 5.67-2.44 6-6.05a12.22 12.22 0 004.94-4.47A12.74 12.74 0 0030 7zm-3.77 6.34A11 11 0 0123 15.59V8h4.9a11.34 11.34 0 01-1.68 4.34z" })));
}
exports.default = SvgTrophyFilled;
//# sourceMappingURL=TrophyFilled.js.map